import { render, staticRenderFns } from "./lead.vue?vue&type=template&id=687c5b24&scoped=true"
import script from "./lead.vue?vue&type=script&lang=js"
export * from "./lead.vue?vue&type=script&lang=js"
import style0 from "./lead.vue?vue&type=style&index=0&id=687c5b24&prod&lang=scss"
import style1 from "./lead.vue?vue&type=style&index=1&id=687c5b24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687c5b24",
  null
  
)

export default component.exports